import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '@/env/environment';
import { resolveCanonicalAirportCode } from '@/common/utils/seo/airport-canonical.util';

@Injectable({ providedIn: 'root' })
export class CanonicalService {
    constructor(
        @Inject(DOCUMENT) private readonly doc: Document,
        private readonly router: Router,
    ) {}

    init(): void {
        this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe((e) => this.setCanonical(e.urlAfterRedirects));
    }

    private setCanonical(url: string): void {
        const path = this.resolvePath(url);
        let link = this.doc.head.querySelector<HTMLLinkElement>(
            'link[rel="canonical"]',
        );
        if (!link) {
            link = this.doc.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.doc.head.appendChild(link);
        }
        link.setAttribute('href', `${environment.siteUrl}${path}`);
    }

    private resolvePath(url: string): string {
        let path = url.split(/[?#]/)[0]; // sin query ni hash
        while (path.endsWith('/')) {
            path = path.slice(0, -1); // sin slash final
        }
        path ||= '/';

        // Aeropuertos que comparten ciudad apuntan al código canónico de su ciudad
        const match =
            /^\/(es|en)\/(destino-aeropuerto|destination-airport)\/(\d+)(\/(?:ciudad|city))?$/.exec(
                path,
            );
        if (!match) {
            return path;
        }

        const [, lang, segment, rawCode] = match;
        const suffix = lang === 'es' ? '/ciudad' : '/city';
        const code = resolveCanonicalAirportCode(Number(rawCode));

        return `/${lang}/${segment}/${code}${suffix}`;
    }
}
